exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".caseProcedure-all-btn[data-v-5845b0f4]{margin-left:20px;margin-top:16px}.caseProcedure-table[data-v-5845b0f4]{margin-top:16px}.pagination[data-v-5845b0f4]{margin-top:12px;text-align:right}[data-v-5845b0f4] .el-table__body td{padding:8px 0 !important;height:40px !important}.log-content[data-v-5845b0f4]{font-size:16px}.log-content .log-content-item[data-v-5845b0f4]{margin:20px 0}.log-content .log-content-item .log-content-item-span[data-v-5845b0f4]{display:inline-block;margin-left:30px}\n", ""]);

// exports
